import { useEffect, useState } from "react";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { connect } from "react-redux";
import { TableColumns } from "./components/TableColumns";
import { fetchCommercialActiveUsers } from "modules/user_management/commercial_user/user/state/action";
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const CommercialActiveUserTable: React.FC<Props> = ({
  fetchCommercialUsers,
  onFetchCommercialActiveUsers,
}) => {
  const [limit, setLimit] = useState(50);
  const [offset, setOffset] = useState(0)
  const [hasNext] = useState(true);
  const [pageIndex, setPageIndex] = useState(0)
  const commercialUserData = fetchCommercialUsers?.commercialActiveUsers;
  useEffect(() => {
    onFetchCommercialActiveUsers(limit, offset);
  }, [onFetchCommercialActiveUsers, limit, offset]);

  const handlePaginationChange = (newLimit: number, newOffset: number) => {
    const newPageIndex = Math.floor(newOffset / newLimit);
    setLimit(newLimit);
    setOffset(newOffset);
    setPageIndex(newPageIndex);
    onFetchCommercialActiveUsers(newLimit, newOffset);
  };
  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "commercial_users.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <ServerTable
        headers={["Report", "Commercial Active Users"]}
        data={commercialUserData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <div>
            <button
              className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
              onClick={() => downloadExcel(commercialUserData)}
            >
              Download Excel
            </button>
          </div>
        }
        onPaginationChange={handlePaginationChange}
        pageIndex={pageIndex}
        pageSize={limit}
        hasNext={hasNext}
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchCommercialUsers: state.commercialUser.commercialActiveUserState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchCommercialActiveUsers: (limit:number, offset:number) => dispatch(fetchCommercialActiveUsers(limit, offset)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommercialActiveUserTable);
